import { ArtworkDetailsColumn } from "../ArtworkDetailsColumn";
import { Box } from "@chakra-ui/react";
import { FC } from "react";
import { getSalePrice, ISale } from "state/sales";
import { SolUsdDisplay } from "components/SolUsdDisplay";
import { useCustomBreakpoints } from "hooks/useCustomBreakpoints";
import { SupplyDetails } from "./SupplyDetails";

interface Props {
  sale?: ISale;
}

export const ParticipatedDetails: FC<Props> = ({ sale }) => {
  const { xlUp, xxlUp } = useCustomBreakpoints();

  if (!sale) return null;

  return (
    <>
      {xxlUp && <Box px={6} w="full" />}

      {xlUp && (
        <ArtworkDetailsColumn title="Sold price">
          <SolUsdDisplay sol={getSalePrice(sale) || 0} />
        </ArtworkDetailsColumn>
      )}

      <ArtworkDetailsColumn title="Supply">
        <SupplyDetails {...sale.artwork.prints} />
      </ArtworkDetailsColumn>
    </>
  );
};
